import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const stationTimeOffset = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATISTICS_STATION:
      return null;
    case actionTypes.SET_STATION_TIME_OFFSET:
      return action.stationTimeOffset;
    default:
      return state;
  }
}

const selectedStatisticsStationName = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATISTICS_STATION:
      return action.stationName;
    case actionTypes.RESET_STATISTICS_STATION:
      return action.data;
    case actionTypes.RESET_BI_DIRECTIONAL_STATION:
        return action.data;
    default:
      return state;
  }
}

const energyMeterList = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_ENERGY_METER_LIST:
      return action.data;
    default:
      return state;
  }
}

const statisticsTotalize = (state = null, action) => {
  switch (action.type) {
    case actionTypes.GET_STATISTICS_TOTALIZE:
      return action.data;
    case actionTypes.RESET_STATISTICS_STATION:
      return null;
    default:
      return state;
  }
}

const statisticsFilter = (state = {
  type: "",
  facilitys: "",
  time: "all"
}, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECT_YEAR:
      return {
        ...state,
        time: action.selectedYear
      };
    case actionTypes.GET_ENERGY_METER_LIST:
      return {
        type: action.data[0].type,
        facilitys: action.data[0].facilitys.split(","),
        time: "all"
      };
    case actionTypes.GET_STATISTICS_TYPE:
      return {
        ...state,
        type: action.data
      };
    case actionTypes.GET_STATISTICS_FACILITYS:
      return {
        ...state,
        facilitys: action.data
      };
    case actionTypes.RESET_STATISTICS_STATION:
      return {
        type: "",
        facilitys: "",
        time: "all"
      };
    default:
      return state;
  }
}

const otherData = (state = null, action) => {
  switch (action.type) {
    case actionTypes.GET_OTHER_DATA:
      return action.data;
    case actionTypes.RESET_STATISTICS_STATION:
      return null;
    default:
      return state;
  }
}

const biDirectionalMeterList = (state = { facilities: [] }, action) => {
  switch (action.type) {
    case actionTypes.GET_BI_DIRECTIONAL_METER:
      return action.data;
    case actionTypes.UPDATE_BI_DIRECTIONAL_METER_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.RESET_BI_DIRECTIONAL_METER_LIST:
      return { facilities: [] }; 
    case actionTypes.RESET_BI_DIRECTIONAL_STATION:
      return { facilities: [] };
    default:
      return state;
  }
}

const selectedView = (state = "all", action) => {
  switch (action.type) {
    case actionTypes.RESET_STATISTICS_VIEW:
      return "all"; // Default or initial view
    case actionTypes.SELECT_VIEW_PERIOD:
      return action.view;
    default:
      return state;
  }
};

const selectedBiDirectionalStation = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_BI_DIRECTIONAL_STATION:
      return action.stationName;
    case actionTypes.RESET_BI_DIRECTIONAL_STATION:
      return "";
    default:
      return state;
  }
};


const biDirectionalEnergyDataDates = (state = { data: {}, loading: false, error: null }, action) => {
  switch (action.type) {
    case actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_REQUEST:
      return { ...state, loading: true, error: null };
    
    case actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: null
      };
    
    case actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_FAILURE:
      return { ...state, loading: false, data: {}, error: action.error };
    
    case actionTypes.RESET_STATISTICS_DATE_SELECTIONS:
      return { data: {}, loading: false, error: null }; // Reset dates when station changes
    
    default:
      return state;
  }
};

const selectedDay = (state = "", action) => {
  switch (action.type) {
    case actionTypes.RESET_STATISTICS_DATE_SELECTIONS:
      return ""; // Clear the selected day
    case actionTypes.SET_SELECTED_DAY:
      return action.day;
    default:
      return state;
  }
};

const selectedMonth = (state = "", action) => {
  switch (action.type) {
    case actionTypes.RESET_STATISTICS_DATE_SELECTIONS:
      return ""; // Clear the selected month
    case actionTypes.SET_SELECTED_MONTH:
      return action.month;
    default:
      return state;
  }
};

const selectedYear = (state = "", action) => {
  switch (action.type) {
    case actionTypes.RESET_STATISTICS_DATE_SELECTIONS:
      return ""; // Clear the selected year
    case actionTypes.SET_SELECTED_YEAR:
      return action.year;
    default:
      return state;
  }
};


const biDirectionalEnergyFilter = (state = { facilities: [], type: "all", time: "" }, action) => {
  switch (action.type) {
    case actionTypes.SELECT_VIEW_PERIOD:
      switch (action.view) {
        case "all":
          return { ...state, type: "all", time: "" };
        case "year":
          return { ...state, type: "year", time: action.year || "" };
        case "month":
          return { ...state, type: "month", time: action.month || "" };
        case "day":
          return { ...state, type: "day", time: action.day || "" };
        default:
          return state;
      }

    case actionTypes.GET_BI_DIRECTIONAL_METER:
      return {
        ...state,
        facilities: action.data ? action.data.facilities : [], // Update facilities or clear if no data
      };

    case actionTypes.UPDATE_BI_DIRECTIONAL_ENERGY_FILTER:
      console.log("Updated Facilities Reducer: ", action.payload); // Log the action payload
      return {
        ...state,
        ...action.payload, // Update the filter with the payload
      };

    case actionTypes.RESET_BI_DIRECTIONAL_STATION:
      return { facilities: [], type: "all", time: "" }; // Reset the filter when resetting the station

    default:
      return state;
  }
};



const biDirectionalEnergyData = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_BI_DIRECTIONAL_ENERGY_DATA:
      return action.data; // an array of energy data objects
    case actionTypes.RESET_BI_DIRECTIONAL_DATA:
      return [];
    default:
      return state;
  }
};

//previous code working
  const portfolioDetails = (state = { 
    userRole: "", 
    companyList: [], 
    countryList: [],
    cityList: [],
    projectList: [], 
    yearList: [], 
    stationList: [], 
    stationDetails: [], // New field to store station details
    stationsTotal: 0,   // New field to store total station count
    loading: false, 
    error: null 
  }, action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_DETAILS_REQUEST:
        return { ...state, loading: true, error: null };

      case actionTypes.GET_PORTFOLIO_DETAILS_SUCCESS:
        return { 
          ...state, 
          loading: false, 
          error: null,
          userRole: action.data.userRole || "", 
          companyList: action.data.companyList || [], 
          countryList: action.data.countryList || [],
          cityList: action.data.cityList || [],
          projectList: action.data.projectList || [], 
          yearList: action.data.yearList || [], 
          stationList: action.data.stationList || [],
          stationDetails: action.data.stationDetails || [], // Store station descriptions
          stationsTotal: action.data.stationsTotal || 0,   // Store total stations count
        };

      case actionTypes.GET_PORTFOLIO_DETAILS_FAILURE:
        return { 
          ...state, 
          loading: false, 
          error: action.error, 
          userRole: "", 
          companyList: [], 
          countryList: [],
          cityList: [],
          projectList: [], 
          yearList: [], 
          stationList: [],
          stationDetails: [], 
          stationsTotal: 0,
        };

      case actionTypes.RESET_PORTFOLIO_DETAILS_FILTER:
        return { 
          userRole: "", 
          companyList: [], 
          countryList: [],
          cityList: [],
          projectList: [], 
          yearList: [], 
          stationList: [], 
          stationDetails: [],
          stationsTotal: 0,
          loading: false, 
          error: null 
        };

      case actionTypes.UPDATE_PORTFOLIO_DETAILS_FILTER:
        return {
          ...state,
          ...action.payload // Merge the updated values from action.payload
        };

      default:
        return state;
    }
  };


  const selectedPortfolioCompany = (state = "", action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_TOTALIZE_DATA:
        return action.payload.companyName || state; // Set from companyName inside portfolioTotalize
      case actionTypes.SET_SELECTED_PORTFOLIO_COMPANY:
        return action.selectedPortfolioCompany || state; 
      default:
        return state;
    }
  };
  
  
  
  const selectedPortfolioProject = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_PROJECT:
        return ""; // Clear the selected project
      case actionTypes.SET_SELECTED_PORTFOLIO_PROJECT: // Fixed action type
        return action.selectedPortfolioProject;
      default:
        return state;
    }
  };

  const selectedPortfolioCountry = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_COUNTRY:
        return ""; // Clear the selected COUNTRY
      case actionTypes.SET_SELECTED_PORTFOLIO_COUNTRY: // Fixed action type
        return action.selectedPortfolioCountry;
      default:
        return state;
    }
  };

  const selectedPortfolioCity = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_CITY:
        return ""; // Clear the selected CITY
      case actionTypes.SET_SELECTED_PORTFOLIO_CITY: // Fixed action type
        return action.selectedPortfolioCity;
      default:
        return state;
    }
  };
  
  const selectedPortfolioYear = (state = "all", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_YEAR:
        return "all"; // Default year   
      case actionTypes.SET_SELECTED_PORTFOLIO_YEAR:
        return action.selectedPortfolioYear; // Fixed the property
      default:
        return state;
    }
  };
  
  const selectedPortfolioStations = (state = [], action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_STATIONS:
        return action.stationsData; // Assuming the payload is an array
      case actionTypes.UPDATE_SELECTED_PORTFOLIO_STATIONS:
        return [...state, ...action.payload]; // Merge new stations with existing ones
      case actionTypes.RESET_SELECTED_PORTFOLIO_STATIONS:
        return []; // Reset to an empty array
      default:
        return state;
    }
  };

  const portfolioData = (state = null, action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_DATA:
        return action.data;
      case actionTypes.GET_PORTFOLIO_DATA_FAILURE:
        return null; // Reset to null on failure
      case actionTypes.RESET_PORTFOLIO_DATA:
        return null; // Reset to null when explicitly requested
      default:
        return state;
    }
  };  

  const portfolioTotalize = (state =[], 
  action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_TOTALIZE_DATA:
        return { ...state, ...action.payload }; // Corrected spread syntax
      default:
        return state;
    }
  };

  const portfolioLevels = (state = [], action) => {
    switch (action.type) {
      case actionTypes.FETCH_PORTFOLIO_LEVELS_SUCCESS:
        return action.payload;
      case actionTypes.FETCH_PORTFOLIO_LEVELS_FAILURE:
        return []; // Reset to an empty array on failure
      default:
        return state;
    }
  };

  const selectedPortfolioLevel = (state = "country", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_LEVEL:
        return action.selectedPortfolioLevel || state;
      case actionTypes.RESET_SELECTED_PORTFOLIO_LEVEL:
        return "country"; // Default reset to 'country'
      case actionTypes.FETCH_PORTFOLIO_LEVELS_SUCCESS:
        const defaultLevel = action.payload.find(level => level.portfolioSelection.toLowerCase() === 'country');
        return defaultLevel ? defaultLevel.portfolioSelection : state; 
      default:
        return state;
    }
  };

  const portfolioStatisticsData = (state = null, action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_STATISTICS_DATA:
        return action.data;
      case actionTypes.GET_PORTFOLIO_STATISTICS_DATA_FAILURE:
        return null; // Reset to null on failure
      case actionTypes.RESET_PORTFOLIO_STATISTICS_DATA:
        return null; // Reset to null when explicitly requested
      default:
        return state;
    }
  };  

  const selectedPortfolioInfoCompany = (state = "", action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_INFO:
        return action.payload.company || state; // Set from companyName inside portfolioTotalize
      case actionTypes.SET_PORTFOLIO_INFO_COMPANY:
        return action.selectedPortfolioInfoCompany || state; 
      default:
        return state;
    }
  };
  
  const portfolioInfo = (state =[], 
  action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_INFO:
        return { ...state, ...action.payload }; 
      default:
        return state;
    }
  };
   
export default combineReducers({
  selectedStatisticsStationName,
  stationTimeOffset,
  portfolioLevels,
  portfolioTotalize,
  selectedPortfolioLevel,
  selectedPortfolioCompany,
  selectedPortfolioCity,
  selectedPortfolioCountry,
  selectedPortfolioProject,
  selectedPortfolioYear,
  selectedPortfolioStations,
  portfolioDetails,
  portfolioData,
  portfolioStatisticsData,
  energyMeterList,
  statisticsTotalize,
  statisticsFilter,
  otherData,
  selectedBiDirectionalStation,
  biDirectionalMeterList,
  selectedView,
  selectedDay,
  selectedMonth,
  selectedYear,
  biDirectionalEnergyDataDates,
  biDirectionalEnergyFilter,
  biDirectionalEnergyData,
  selectedPortfolioInfoCompany,
  portfolioInfo
});

const getCurrentState = state => state.stationStatistics;
export const getStationTimeOffset = state => getCurrentState(state).stationTimeOffset;
export const getSelectedStatisticsStationName = state => getCurrentState(state).selectedStatisticsStationName;

export const getSelectedPortfolioLevel = state => getCurrentState(state).selectedPortfolioLevel;
export const getPortfolioLevels = state => getCurrentState(state).portfolioLevels;
export const getPortfolioTotalize = state => getCurrentState(state).portfolioTotalize;
export const getSelectedPortfolioCompany = state => getCurrentState(state).selectedPortfolioCompany;
export const getSelectedPortfolioCountry = state => getCurrentState(state).selectedPortfolioCountry;
export const getSelectedPortfolioCity = state => getCurrentState(state).selectedPortfolioCity;
export const getSelectedPortfolioProject = state => getCurrentState(state).selectedPortfolioProject;
export const getSelectedPortfolioYear = state => getCurrentState(state).selectedPortfolioYear;
export const getPortfolioData = state => getCurrentState(state).portfolioData;
export const getPortfolioStatisticsData = state => getCurrentState(state).portfolioStatisticsData;

export const getPortfolioDetails = state => getCurrentState(state).portfolioDetails;
export const getSelectedBiDirectionalStation = state => getCurrentState(state).selectedBiDirectionalStation;

export const getEnergyMeterList = state => getCurrentState(state).energyMeterList;
export const getStatisticsTotalize = state => getCurrentState(state).statisticsTotalize;
export const getStatisticsFilter = state => getCurrentState(state).statisticsFilter;

export const getOtherData = state => getCurrentState(state).otherData;
export const getBiDirectionalMeter = state => getCurrentState(state).biDirectionalMeterList;

export const getSelectedView = state => getCurrentState(state).selectedView;
export const getSelectedYear = state => getCurrentState(state).selectedYear;
export const getSelectedMonth = state => getCurrentState(state).selectedMonth;
export const getSelectedDay = state => getCurrentState(state).selectedDay;

export const getBiDirectionalEnergyFilter = state => getCurrentState(state).biDirectionalEnergyFilter;
export const getBiDirectionalEnergyData = state => getCurrentState(state).biDirectionalEnergyData;
export const getBiDirectionalEnergyDataDates = state => getCurrentState(state).biDirectionalEnergyDataDates;
export const getSelectedPortfolioInfoCompany = state => getCurrentState(state).selectedPortfolioInfoCompany;
export const getPortfolioInfo = state => getCurrentState(state).portfolioInfo;